// src/pages/Enseignants/Attendance/components/AttendanceEmptyState.jsx

import React from "react";
import { FaClipboardList } from "react-icons/fa";

export default function AttendanceEmptyState() {
  return (
    <div className="mt-5 rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-white text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <FaClipboardList className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucun adhérent trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun adhérent ne correspond aux filtres sélectionnés. Vérifiez le
        groupe, la saison, le statut ou la recherche.
      </p>
    </div>
  );
}